import { spaceModel } from 'APP/model/model';

import { ValidationErrorType } from './fields';

export const spaceMarketLinkAsyncValidation = async ({
  value,
  errorToText,
}: {
  value: string;
  errorToText: Partial<Record<ValidationErrorType, string>>;
}): Promise<string | null> => {
  let isValid;

  try {
    isValid = await spaceModel.validateMarketUrl({
      url: value,
    });
  } catch {
    isValid = false;
  }

  return isValid ? null : errorToText[ValidationErrorType.Invalid] || '';
};
